export const MODAL_ADD_USER = 'ADD_USER';
export const MODAL_ACTIVE_USER = 'ACTIVE_USER';
export const MODAL_DISABLED_USER = 'DISABLED_USER';
export const MODAL_ACTIVE_ADMIN = 'ACTIVE_ADMIN';
export const MODAL_DISABLED_ADMIN = 'DISABLED_ADMIN';
export const MODAL_ACTIVE_ACCOUNT = 'ACTIVE_ACCOUNT';
export const MODAL_DISABLED_ACCOUNT = 'DISABLED_ACCOUNT';

export const NAME_PROMOTION_FICC = 'FICC';
export const NAME_PROMOTION_SICC = 'SICC';

export const PromotionsNamesArray = [
  NAME_PROMOTION_FICC,
  NAME_PROMOTION_SICC,
];

export enum LinkExternalSteps {
  default = '-1',
  code = '0',
  type = '1',
  information = '2',
  warning = '3',
  signature = '4',
  summary = '5',
  finish = '6',
}

export const InvitationSenders = [
  'Robertoperri@imparcapital.com',
  'Carmenpanadero@imparcapital.com',
  'Emilianoguerrero@imparcapital.com',
  'Iranzuvicente@imparcapital.com',
  'Vanesadiaz@imparcapital.com',
  'Mariajose@imparcapital.com',
  'Sofiagil@imparcapital.com',
  'Isabellaparis@imparcapital.com',
  'Javiercanas@imparcapital.com',
  'Jaimegomez@imparcapital.com',
  'Javiervillar@imparcapital.com',
  'claudiaiglesias@imparcapital.com',
];
